










export default {
  name: "RadioButton",
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
    },
    first: {
      type: Boolean,
      required: false,
    },
    last: {
      type: Boolean,
      required: false,
    },
  }
}
